// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseUnreachableCluster } from './ResponseUnreachableCluster';
import {
  ResponseUnreachableClusterFromJSON,
  ResponseUnreachableClusterFromJSONTyped,
  ResponseUnreachableClusterToJSON,
  ResponseUnreachableClusterToJSONTyped,
} from './ResponseUnreachableCluster';
import type { ResponseStaleCluster } from './ResponseStaleCluster';
import {
  ResponseStaleClusterFromJSON,
  ResponseStaleClusterFromJSONTyped,
  ResponseStaleClusterToJSON,
  ResponseStaleClusterToJSONTyped,
} from './ResponseStaleCluster';
import type { ResponseClusterRolloutSummary } from './ResponseClusterRolloutSummary';
import {
  ResponseClusterRolloutSummaryFromJSON,
  ResponseClusterRolloutSummaryFromJSONTyped,
  ResponseClusterRolloutSummaryToJSON,
  ResponseClusterRolloutSummaryToJSONTyped,
} from './ResponseClusterRolloutSummary';

/**
 *
 * @export
 * @interface ResponseClusterRolloutList
 */
export interface ResponseClusterRolloutList {
  /**
   *
   * @type {Array<ResponseClusterRolloutSummary>}
   * @memberof ResponseClusterRolloutList
   */
  items?: Array<ResponseClusterRolloutSummary>;
  /**
   * NextCursor is omitted on the last page.
   * @type {string}
   * @memberof ResponseClusterRolloutList
   */
  nextCursor?: string;
  /**
   * StaleClusters lists clusters whose watch is failing, so their items are
   * last-known state; omitted when every watch is healthy.
   * @type {Array<ResponseStaleCluster>}
   * @memberof ResponseClusterRolloutList
   */
  staleClusters?: Array<ResponseStaleCluster>;
  /**
   * TotalCount is the number of cluster rollouts matching the filters,
   * regardless of the page size.
   * @type {number}
   * @memberof ResponseClusterRolloutList
   */
  totalCount?: number;
  /**
   * UnreachableClusters lists clusters that couldn't be reached while
   * building this view; omitted when every cluster responded.
   * @type {Array<ResponseUnreachableCluster>}
   * @memberof ResponseClusterRolloutList
   */
  unreachableClusters?: Array<ResponseUnreachableCluster>;
}

/**
 * Check if a given object implements the ResponseClusterRolloutList interface.
 */
export function instanceOfResponseClusterRolloutList(
  value: object,
): value is ResponseClusterRolloutList {
  return true;
}

export function ResponseClusterRolloutListFromJSON(
  json: any,
): ResponseClusterRolloutList {
  return ResponseClusterRolloutListFromJSONTyped(json, false);
}

export function ResponseClusterRolloutListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseClusterRolloutList {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(
            ResponseClusterRolloutSummaryFromJSON,
          ),
    nextCursor: json['nextCursor'] == null ? undefined : json['nextCursor'],
    staleClusters:
      json['staleClusters'] == null
        ? undefined
        : (json['staleClusters'] as Array<any>).map(
            ResponseStaleClusterFromJSON,
          ),
    totalCount: json['totalCount'] == null ? undefined : json['totalCount'],
    unreachableClusters:
      json['unreachableClusters'] == null
        ? undefined
        : (json['unreachableClusters'] as Array<any>).map(
            ResponseUnreachableClusterFromJSON,
          ),
  };
}

export function ResponseClusterRolloutListToJSON(
  json: any,
): ResponseClusterRolloutList {
  return ResponseClusterRolloutListToJSONTyped(json, false);
}

export function ResponseClusterRolloutListToJSONTyped(
  value?: ResponseClusterRolloutList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(
            ResponseClusterRolloutSummaryToJSON,
          ),
    nextCursor: value['nextCursor'],
    staleClusters:
      value['staleClusters'] == null
        ? undefined
        : (value['staleClusters'] as Array<any>).map(
            ResponseStaleClusterToJSON,
          ),
    totalCount: value['totalCount'],
    unreachableClusters:
      value['unreachableClusters'] == null
        ? undefined
        : (value['unreachableClusters'] as Array<any>).map(
            ResponseUnreachableClusterToJSON,
          ),
  };
}
